var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container visitReportAdd" },
    [
      _c("div", { staticClass: "searchBox" }, [
        _c(
          "div",
          { staticClass: "searchBox_top" },
          [
            _vm.showButton
              ? [
                  _vm.isSave
                    ? _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "acl",
                              rawName: "v-acl",
                              value: _vm.Msv - _vm.reportSave,
                              expression: "Msv-reportSave",
                            },
                          ],
                          attrs: { type: "primary" },
                          on: {
                            click: function ($event) {
                              return _vm.saveVisit("queryCondition")
                            },
                          },
                        },
                        [_vm._v(_vm._s(_vm.$t("visitPlan.draftSave")))]
                      )
                    : _vm._e(),
                  _vm.isSubmit
                    ? _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "acl",
                              rawName: "v-acl",
                              value: _vm.Msv - _vm.reportSubmit,
                              expression: "Msv-reportSubmit",
                            },
                          ],
                          attrs: { type: "primary" },
                          on: {
                            click: function ($event) {
                              return _vm.submitVisitPlan("queryCondition")
                            },
                          },
                        },
                        [_vm._v(_vm._s(_vm.$t("common.submit")))]
                      )
                    : _vm._e(),
                ]
              : _vm._e(),
            _c(
              "el-button",
              { attrs: { type: "primary" }, on: { click: _vm.goBack } },
              [_vm._v(_vm._s(_vm.$t("common.close")))]
            ),
            _vm.showButton && _vm.isSave
              ? [
                  _c("br"),
                  _c(
                    "label",
                    { staticStyle: { "font-size": "12px", color: "#F56C6C" } },
                    [_vm._v(_vm._s(_vm.$t("visitPlan.operationTips")))]
                  ),
                ]
              : _vm._e(),
          ],
          2
        ),
      ]),
      _c(
        "el-tabs",
        {
          model: {
            value: _vm.activeName,
            callback: function ($$v) {
              _vm.activeName = $$v
            },
            expression: "activeName",
          },
        },
        [
          _c(
            "el-tab-pane",
            {
              attrs: {
                label: _vm.$t("visitPlan.ReportDetails"),
                name: "first",
              },
            },
            [
              _c(
                "el-card",
                { staticClass: "box-card" },
                [
                  _c(
                    "div",
                    {
                      staticClass: "clearfix",
                      attrs: { slot: "header" },
                      slot: "header",
                    },
                    [_c("span", [_vm._v("MSV Basic Info")])]
                  ),
                  _c(
                    "el-form",
                    {
                      ref: "queryCondition",
                      attrs: {
                        model: _vm.queryCondition,
                        rules: _vm.queryConditionRules,
                        inline: "",
                        "label-width": "240px",
                      },
                    },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "MSV 单据编号", prop: "msvNo" } },
                        [
                          _c("el-input", {
                            attrs: { disabled: "", clearable: "" },
                            model: {
                              value: _vm.queryCondition.msvNo,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.queryCondition,
                                  "msvNo",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "queryCondition.msvNo",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("visitPlan.Year"),
                            prop: "year",
                            rules: _vm.fromVisitPlan
                              ? _vm.queryConditionRules.year2
                              : _vm.queryConditionRules.year,
                          },
                        },
                        [
                          _c("el-date-picker", {
                            attrs: {
                              type: "year",
                              clearable: "",
                              "value-format": "yyyy",
                              disabled: _vm.fromVisitPlan,
                              placeholder: "选择年",
                            },
                            model: {
                              value: _vm.queryCondition.year,
                              callback: function ($$v) {
                                _vm.$set(_vm.queryCondition, "year", $$v)
                              },
                              expression: "queryCondition.year",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("visitPlan.Type"),
                            prop: "type",
                            rules: _vm.fromVisitPlan
                              ? _vm.queryConditionRules.type2
                              : _vm.queryConditionRules.type,
                          },
                        },
                        [
                          _vm.isHGS
                            ? _c("el-input", {
                                attrs: { readonly: "", disabled: "" },
                                model: {
                                  value: _vm.queryCondition.type,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.queryCondition, "type", $$v)
                                  },
                                  expression: "queryCondition.type",
                                },
                              })
                            : _vm._e(),
                          !_vm.isHGS
                            ? _c(
                                "el-select",
                                {
                                  attrs: {
                                    clearable: "",
                                    disabled: _vm.fromVisitPlan,
                                  },
                                  on: { change: _vm.typeChange },
                                  model: {
                                    value: _vm.queryCondition.type,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.queryCondition, "type", $$v)
                                    },
                                    expression: "queryCondition.type",
                                  },
                                },
                                _vm._l(_vm.typeList, function (item, index) {
                                  return _c("el-option", {
                                    key: index,
                                    attrs: {
                                      label: item.chineseValue,
                                      value: item.code,
                                    },
                                  })
                                }),
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "Category",
                            prop: "category",
                            rules: _vm.istypeFood
                              ? _vm.queryConditionRules.category
                              : _vm.queryConditionRules.category2,
                          },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: {
                                clearable: "",
                                disabled: _vm.fromVisitPlan,
                              },
                              on: { change: _vm.CategoryChange },
                              model: {
                                value: _vm.queryCondition.category,
                                callback: function ($$v) {
                                  _vm.$set(_vm.queryCondition, "category", $$v)
                                },
                                expression: "queryCondition.category",
                              },
                            },
                            _vm._l(_vm.categoryList, function (item, index) {
                              return _c("el-option", {
                                key: index,
                                attrs: { label: item.NAME, value: item.NAME },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("visitPlan.SupplierFacility"),
                            prop: "plantName",
                            rules: _vm.fromVisitPlan
                              ? _vm.queryConditionRules.plantName2
                              : _vm.queryConditionRules.plantName,
                          },
                        },
                        [
                          _c(
                            "el-input",
                            {
                              attrs: {
                                disabled: _vm.fromVisitPlan,
                                clearable: "",
                              },
                              model: {
                                value: _vm.queryCondition.plantName,
                                callback: function ($$v) {
                                  _vm.$set(_vm.queryCondition, "plantName", $$v)
                                },
                                expression: "queryCondition.plantName",
                              },
                            },
                            [
                              _c("el-button", {
                                attrs: {
                                  slot: "append",
                                  icon: "el-icon-search",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.searchSupplier(_vm.fromVisitPlan)
                                  },
                                },
                                slot: "append",
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("visitPlan.ReportBy"),
                            prop: "createBy",
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: { disabled: "" },
                            model: {
                              value: _vm.createBy,
                              callback: function ($$v) {
                                _vm.createBy = $$v
                              },
                              expression: "createBy",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "Report date", prop: "createDate" } },
                        [
                          _c("el-date-picker", {
                            attrs: { type: "date", disabled: "" },
                            model: {
                              value: _vm.queryCondition.createDate,
                              callback: function ($$v) {
                                _vm.$set(_vm.queryCondition, "createDate", $$v)
                              },
                              expression: "queryCondition.createDate",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "Visit Type", prop: "visitType" } },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: {
                                clearable: "",
                                disabled: _vm.otherInput,
                              },
                              model: {
                                value: _vm.queryCondition.visitType,
                                callback: function ($$v) {
                                  _vm.$set(_vm.queryCondition, "visitType", $$v)
                                },
                                expression: "queryCondition.visitType",
                              },
                            },
                            _vm._l(_vm.visitTypeList, function (item, index) {
                              return _c("el-option", {
                                key: index,
                                attrs: {
                                  label: item.chineseValue,
                                  value: item.code,
                                  disabled: _vm.otherInput,
                                },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          staticClass: "ReportTo textareaClass",
                          attrs: {
                            label: "Report to（Supplier）",
                            prop: "supplierEmail",
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              type: "textarea",
                              clearable: "",
                              disabled: _vm.otherInput,
                              maxlength: "400",
                              autosize: { minRows: 3, maxRows: 6 },
                              placeholder: "多个邮箱用英文逗号隔开",
                            },
                            model: {
                              value: _vm.queryCondition.supplierEmail,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.queryCondition,
                                  "supplierEmail",
                                  $$v
                                )
                              },
                              expression: "queryCondition.supplierEmail",
                            },
                          }),
                          _c(
                            "div",
                            {
                              staticClass: "smallIcons",
                              on: {
                                click: function ($event) {
                                  return _vm.searchSupplierEmail(_vm.otherInput)
                                },
                              },
                            },
                            [_c("i", { staticClass: "el-icon-search" })]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          staticClass: "ReportTo textareaClass",
                          attrs: {
                            label: "Report to（McD）",
                            prop: "mcdEmail",
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              type: "textarea",
                              clearable: "",
                              disabled: _vm.otherInput,
                              maxlength: "400",
                              autosize: { minRows: 3, maxRows: 6 },
                              placeholder: "多个邮箱用英文逗号隔开",
                            },
                            model: {
                              value: _vm.queryCondition.mcdEmail,
                              callback: function ($$v) {
                                _vm.$set(_vm.queryCondition, "mcdEmail", $$v)
                              },
                              expression: "queryCondition.mcdEmail",
                            },
                          }),
                          _c(
                            "div",
                            {
                              staticClass: "smallIcons",
                              on: {
                                click: function ($event) {
                                  return _vm.searchMcD(_vm.otherInput)
                                },
                              },
                            },
                            [_c("i", { staticClass: "el-icon-search" })]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "Attendees Supplier",
                            prop: "attendeesSupplier",
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              type: "textarea",
                              autosize: { minRows: 3, maxRows: 6 },
                              clearable: "",
                              disabled: _vm.otherInput,
                            },
                            model: {
                              value: _vm.queryCondition.attendeesSupplier,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.queryCondition,
                                  "attendeesSupplier",
                                  $$v
                                )
                              },
                              expression: "queryCondition.attendeesSupplier",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            "min-width": "200",
                            label: "Attendees McDonald’s(& On behalf)",
                            prop: "attendeesMcd",
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              type: "textarea",
                              autosize: { minRows: 3, maxRows: 6 },
                              clearable: "",
                              disabled: _vm.otherInput,
                            },
                            model: {
                              value: _vm.queryCondition.attendeesMcd,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.queryCondition,
                                  "attendeesMcd",
                                  $$v
                                )
                              },
                              expression: "queryCondition.attendeesMcd",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "Mgt. recap", prop: "mgtRecap" } },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: {
                                clearable: "",
                                disabled: _vm.otherInput,
                              },
                              model: {
                                value: _vm.queryCondition.mgtRecap,
                                callback: function ($$v) {
                                  _vm.$set(_vm.queryCondition, "mgtRecap", $$v)
                                },
                                expression: "queryCondition.mgtRecap",
                              },
                            },
                            _vm._l(_vm.mgtRecapList, function (item, index) {
                              return _c("el-option", {
                                key: index,
                                attrs: {
                                  label: item.chineseValue,
                                  value: item.code,
                                },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "MSV Result", prop: "msvResult" } },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: {
                                clearable: "",
                                disabled: _vm.otherInput,
                              },
                              model: {
                                value: _vm.queryCondition.msvResult,
                                callback: function ($$v) {
                                  _vm.$set(_vm.queryCondition, "msvResult", $$v)
                                },
                                expression: "queryCondition.msvResult",
                              },
                            },
                            _vm._l(_vm.msvResultList, function (item, index) {
                              return _c("el-option", {
                                key: index,
                                attrs: {
                                  label: item.chineseValue,
                                  value: item.code,
                                },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-row",
                        [
                          _c("el-form-item", {
                            attrs: { label: "On-site observations Number" },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-row",
                        [
                          _c(
                            "el-form-item",
                            {
                              staticClass: "highScoreClass",
                              attrs: { label: "High Risk", prop: "highScore" },
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  clearable: "",
                                  maxLength: "5",
                                  oninput:
                                    "value=value.replace(/^\\.+|[^\\d.]/g,'')",
                                  disabled: _vm.otherInput,
                                },
                                on: { blur: _vm.highScoreChange },
                                model: {
                                  value: _vm.queryCondition.highScore,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.queryCondition,
                                      "highScore",
                                      $$v
                                    )
                                  },
                                  expression: "queryCondition.highScore",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              staticClass: "ScoreClass",
                              attrs: {
                                label: "Medium Risk",
                                prop: "mediumScore",
                              },
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  clearable: "",
                                  maxLength: "5",
                                  oninput:
                                    "value=value.replace(/^\\.+|[^\\d.]/g,'')",
                                  disabled: _vm.otherInput,
                                },
                                on: { blur: _vm.mediumScoreChange },
                                model: {
                                  value: _vm.queryCondition.mediumScore,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.queryCondition,
                                      "mediumScore",
                                      $$v
                                    )
                                  },
                                  expression: "queryCondition.mediumScore",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              staticClass: "ScoreClass",
                              attrs: { label: "Low Risk", prop: "lowScore" },
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  clearable: "",
                                  maxLength: "5",
                                  oninput:
                                    "value=value.replace(/^\\.+|[^\\d.]/g,'')",
                                  disabled: _vm.otherInput,
                                },
                                on: { blur: _vm.lowScoreChange },
                                model: {
                                  value: _vm.queryCondition.lowScore,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.queryCondition,
                                      "lowScore",
                                      $$v
                                    )
                                  },
                                  expression: "queryCondition.lowScore",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "CAP Implementation  Status",
                            prop: "capImplementationStatus",
                          },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: { disabled: !_vm.AllInput },
                              model: {
                                value:
                                  _vm.queryCondition.capImplementationStatus,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.queryCondition,
                                    "capImplementationStatus",
                                    $$v
                                  )
                                },
                                expression:
                                  "queryCondition.capImplementationStatus",
                              },
                            },
                            _vm._l(
                              _vm.capImplementationStatusList,
                              function (item, index) {
                                return _c("el-option", {
                                  key: index,
                                  attrs: {
                                    label: item.chineseValue,
                                    value: item.code,
                                  },
                                })
                              }
                            ),
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          staticClass: "VisitDate",
                          attrs: {
                            label: _vm.$t("visitPlan.VisitDate"),
                            prop: "dataArr",
                            rules: _vm.queryConditionRules.dataArr,
                          },
                        },
                        [
                          _c("el-date-picker", {
                            attrs: {
                              type: "daterange",
                              "range-separator": _vm.$t("common.to"),
                              "start-placeholder": _vm.$t("common.startDate"),
                              "end-placeholder": _vm.$t("common.endDate"),
                              clearable: "",
                              "value-format": "yyyy-MM-dd",
                              disabled: _vm.otherInput,
                            },
                            model: {
                              value: _vm.queryCondition.dataArr,
                              callback: function ($$v) {
                                _vm.$set(_vm.queryCondition, "dataArr", $$v)
                              },
                              expression: "queryCondition.dataArr",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "toolsBox" },
                    [
                      _vm.showButton && !_vm.otherInput
                        ? _c(
                            "el-button",
                            {
                              directives: [
                                {
                                  name: "acl",
                                  rawName: "v-acl",
                                  value: _vm.Msv - _vm.reportAddSubject,
                                  expression: "Msv-reportAddSubject",
                                },
                              ],
                              attrs: { size: "small", type: "primary" },
                              on: { click: _vm.addSubject },
                            },
                            [_vm._v("新增拜访主题")]
                          )
                        : _vm._e(),
                      _vm.showButton && !_vm.otherInput
                        ? _c(
                            "el-button",
                            {
                              directives: [
                                {
                                  name: "acl",
                                  rawName: "v-acl",
                                  value: _vm.Msv - _vm.reportDelSubject,
                                  expression: "Msv-reportDelSubject",
                                },
                              ],
                              attrs: { size: "small", type: "danger" },
                              on: { click: _vm.delSubject },
                            },
                            [_vm._v("删除")]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _c(
                    "el-table",
                    {
                      ref: "PurposeList",
                      staticClass: "purposeList",
                      attrs: { data: _vm.PurposeList, border: "", fit: "" },
                    },
                    [
                      _c("el-table-column", {
                        attrs: { type: "selection", "min-width": "50" },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "serialNumber",
                          label: "序号",
                          width: "60",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          "show-overflow-tooltip": "",
                          prop: "visitPurpose",
                          label: _vm.$t("visitPlan.visitPurpose"),
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c("el-autocomplete", {
                                  staticClass: "inline-input",
                                  attrs: {
                                    "fetch-suggestions": _vm.querySearch,
                                    maxlength: "200",
                                    placeholder: "请输入内容",
                                    clearable: "",
                                    disabled: _vm.otherInput,
                                  },
                                  model: {
                                    value: scope.row.visitPurpose,
                                    callback: function ($$v) {
                                      _vm.$set(scope.row, "visitPurpose", $$v)
                                    },
                                    expression: "scope.row.visitPurpose",
                                  },
                                }),
                              ]
                            },
                          },
                        ]),
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-card",
                {
                  staticClass: "box-card",
                  staticStyle: { "margin-top": "20px" },
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "clearfix",
                      attrs: { slot: "header" },
                      slot: "header",
                    },
                    [_c("span", [_vm._v("附件")])]
                  ),
                  _c(
                    "el-tabs",
                    {
                      model: {
                        value: _vm.activeName2,
                        callback: function ($$v) {
                          _vm.activeName2 = $$v
                        },
                        expression: "activeName2",
                      },
                    },
                    [
                      _c(
                        "el-tab-pane",
                        { attrs: { label: "CQS附件", name: "first" } },
                        [
                          _c(
                            "el-table",
                            {
                              staticClass: "table",
                              attrs: {
                                data: _vm.fileList,
                                border: "",
                                "highlight-current-row": "",
                              },
                            },
                            [
                              _c("el-table-column", {
                                attrs: {
                                  "show-overflow-tooltip": "",
                                  sortable: "",
                                  prop: "documentName",
                                  label: _vm.$t("common.file"),
                                  "min-width": "130px",
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c(
                                          "el-link",
                                          {
                                            attrs: { type: "primary" },
                                            nativeOn: {
                                              click: function ($event) {
                                                return _vm.downloadFileFDP(
                                                  scope.row
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(scope.row.documentName)
                                            ),
                                          ]
                                        ),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                              _vm.isdeleteFile
                                ? _c("el-table-column", {
                                    attrs: {
                                      "show-overflow-tooltip": "",
                                      prop: "tmDocumentId",
                                      "min-width": "130px",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return [
                                              _c(
                                                "el-link",
                                                {
                                                  attrs: { type: "primary" },
                                                  nativeOn: {
                                                    click: function ($event) {
                                                      $event.preventDefault()
                                                      return _vm.deleteFile(
                                                        scope.row.tmDocumentId,
                                                        scope.$index,
                                                        _vm.fileList
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(_vm.$t("common.del"))
                                                  ),
                                                ]
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      4140023628
                                    ),
                                  })
                                : _vm._e(),
                            ],
                            1
                          ),
                          [
                            _c(
                              "el-upload",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.showAccessories,
                                    expression: "showAccessories",
                                  },
                                ],
                                ref: "upload",
                                staticStyle: { float: "left" },
                                attrs: {
                                  action: "upload",
                                  "http-request": _vm.uploadConfirm,
                                  "before-upload": _vm.beforePDFUpload,
                                  "show-file-list": false,
                                  multiple: "",
                                  accept: ".PDF",
                                  name: "file",
                                },
                              },
                              [
                                _c(
                                  "el-button",
                                  {
                                    attrs: {
                                      slot: "trigger",
                                      size: "small",
                                      type: "primary",
                                    },
                                    slot: "trigger",
                                  },
                                  [_vm._v(_vm._s(_vm.$t("common.selectFile")))]
                                ),
                              ],
                              1
                            ),
                          ],
                        ],
                        2
                      ),
                      _c(
                        "el-tab-pane",
                        { attrs: { label: "供应商附件", name: "second" } },
                        [
                          _c(
                            "el-table",
                            {
                              staticClass: "table",
                              attrs: {
                                data: _vm.fileList2,
                                border: "",
                                "highlight-current-row": "",
                              },
                            },
                            [
                              _c("el-table-column", {
                                attrs: {
                                  "show-overflow-tooltip": "",
                                  sortable: "",
                                  prop: "documentName",
                                  label: _vm.$t("common.file"),
                                  "min-width": "130px",
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c(
                                          "el-link",
                                          {
                                            attrs: { type: "primary" },
                                            nativeOn: {
                                              click: function ($event) {
                                                return _vm.downloadFile(
                                                  scope.row
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(scope.row.documentName)
                                            ),
                                          ]
                                        ),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  "show-overflow-tooltip": "",
                                  sortable: "",
                                  prop: "userName",
                                  label: _vm.$t("common.createBy"),
                                  "min-width": "130px",
                                },
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  "show-overflow-tooltip": "",
                                  sortable: "",
                                  prop: "createDate",
                                  label: _vm.$t("common.createDate"),
                                  "min-width": "130px",
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm._f("dateFormatFilter")(
                                                scope.row.createDate,
                                                "YYYY-MM-DD HH:mm:ss"
                                              )
                                            ) +
                                            " "
                                        ),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-tab-pane",
            { attrs: { label: _vm.$t("visitPlan.ModifyLog"), name: "second" } },
            [
              _c(
                "el-table",
                {
                  ref: "logList",
                  attrs: { data: _vm.logList, border: "", fit: "" },
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      "show-overflow-tooltip": "",
                      prop: "action",
                      label: _vm.$t("common.operation"),
                      width: "120",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      "show-overflow-tooltip": "",
                      prop: "detail",
                      label: _vm.$t("common.ModifyContent"),
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      "show-overflow-tooltip": "",
                      prop: "createDate",
                      label: _vm.$t("common.OperationTime"),
                      width: "100",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              _vm._s(
                                _vm._f("dateFormatFilter")(
                                  scope.row.createDate,
                                  "YYYY-MM-DD HH:mm:ss"
                                )
                              )
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      "show-overflow-tooltip": "",
                      prop: "creater",
                      label: _vm.$t("common.OperatorName"),
                      width: "120",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.showSelSupplierDialog,
            "append-to-body": "",
            width: "80%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.showSelSupplierDialog = $event
            },
          },
        },
        [
          _vm.DestroyIncomeStatistics == true
            ? _c("SelSupplier", {
                ref: "supplierSelRef",
                attrs: {
                  categoryLevel1Name: _vm.categoryLevel1Name,
                  categoryLevel2Name: _vm.categoryLevel2Name,
                },
                on: { subCallMethod: _vm.selectSupplierMethod },
              })
            : _vm._e(),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.showSupplierUserDialog,
            "append-to-body": "",
            width: "80%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.showSupplierUserDialog = $event
            },
          },
        },
        [
          _c("SupplierEmail", {
            attrs: { multi: true, emplFlag: "SUP" },
            on: { input: _vm.selectSupplierEmail },
          }),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.showUserDialog,
            "append-to-body": "",
            width: "80%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.showUserDialog = $event
            },
          },
        },
        [
          _c("PickupUser", {
            attrs: { multi: true, emplFlag: "MCD" },
            on: { input: _vm.selectMcD },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }